import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: fetchBaseQuery({ baseUrl: `/api` }),
  keepUnusedDataFor: 5 * 60,
  endpoints: (build) => ({
    getPaymentsPlans: build.query<
      {
        plans: {
          id: string;
          name: string;
          price_id: string;
          metadata: {
            role: string;
            position: number;
            maxPatients: number;
          };
          prices: {
            id: string;
            created_at: string;
            type: string;
            price_id: string;
            mode: 'YEARLY' | 'MONTHLY';
            parent_id: string;
            active: boolean;
            name: string;
            metadata: {
              maxPatients: number;
              unit_amount: number;
              patientsRange: number;
              unit_amount_decimal: string;
              product_id: string;
            };
          }[];
        }[];
      },
      void
    >({
      query: () => `/stripe/plans`,
    }),
  }),
});

export const { useGetPaymentsPlansQuery } = paymentsApi;
